import React from 'react';
import { WaveLoading } from 'react-loadingg';

const Loading = () => <WaveLoading size={200} color="#ffffff" sizeUnit="px" />;

export default Loading;
